import gsap from 'gsap'
import {type Group, Mesh, ShaderMaterial, Vector3, Vector4} from 'three'

import {bgColor} from '../_config'
import {BREAKPOINT} from '../_rawConfig'
import fragmentShader from '../_shaders/cube/rainbowMosaicCube'
import vertexShader from '../_shaders/vertexShader'
import RoundedCubeGeometry from '../modules/cube/RoundedCubeGeometry'

export default class RainbowMozaicCube {
  _cubeGeometry: RoundedCubeGeometry
  mesh: Mesh | null = null
  constructor(_cubeGeometry: RoundedCubeGeometry) {
    this._cubeGeometry = _cubeGeometry
  }
  create(newGroup: Group, tl: gsap.core.Timeline) {
    const progress = new Vector4(0, 0, 0, 0)
    const mesh = new Mesh(
      this._cubeGeometry,
      new ShaderMaterial({
        vertexShader,
        fragmentShader,
        uniforms: {
          uRectData: {value: newGroup.userData.rectData},
          uProgress: {
            value: progress,
          },
          uBgColor: {
            value: bgColor,
          },
        },
        defines: {
          MOSAIC: '',
        },
      }),
    )

    mesh.rotation.order = 'ZXY'
    mesh.scale.set(0.5, 0.5, 0.5)
    mesh.name = 'rainbowCube'

    mesh.userData.position = {
      def: new Vector3(-0.4, 0.4, 0),
      offset: new Vector3(0, 0, 0),
      current: new Vector3(0, 0, 0),
    }

    mesh.userData.rotation = {
      def: new Vector3(Math.PI / 5, -Math.PI * 0.25, Math.PI * 0.25),
      offset: new Vector3(0, Math.PI * 3, 0),
      current: new Vector3(0, 0, 0),
    }

    const duration = 1.5
    const delay = 0.4

    tl.to(
      mesh.userData.position.offset,
      {
        x: 0,
        y: 0,
        z: 0,
        ease: 'expo.out',
        duration,
      },
      delay,
    )
      .to(
        mesh.userData.rotation.offset,
        {
          y: 0,
          ease: 'expo.out',
          duration: 3,
        },
        delay,
      )
      .to(
        progress,
        {
          x: 1,
          ease: 'expo.out',
          duration: 1.0,
        },
        delay,
      )
      .fromTo(
        mesh.scale,
        {
          x: 0,
          y: 0,
          z: 0,
        },
        {
          x: 0.5,
          y: 0.5,
          z: 0.5,
          ease: 'expo.out',
          duration: 2.0,
        },
        delay,
      )

    this.mesh = mesh

    newGroup.add(mesh)
  }

  update() {
    if (!this.mesh) return
    const rainbowCubePos = this.mesh.userData.position
    const rainbowCubeRot = this.mesh.userData.rotation

    rainbowCubePos.current.copy(rainbowCubePos.def).add(rainbowCubePos.offset)
    this.mesh.position.copy(rainbowCubePos.current)
    rainbowCubeRot.current.copy(rainbowCubeRot.def).add(rainbowCubeRot.offset)
    this.mesh.rotation.set(rainbowCubeRot.current.x, rainbowCubeRot.current.y, rainbowCubeRot.current.z)

    this.mesh.scale.set(0.5, 0.5, 0.5)

    if (window.innerWidth <= BREAKPOINT.MOBILE) {
      this.mesh.scale.set(0.4, 0.4, 0.4)
    } else if (window.innerWidth <= BREAKPOINT.TABLET) {
      this.mesh.scale.set(0.4, 0.4, 0.4)
    }
  }
}
